import { render } from "./BlogComponents.vue?vue&type=template&id=9ab1acd2"
import script from "./BlogComponents.vue?vue&type=script&lang=js"
export * from "./BlogComponents.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/dhaffaabdillah/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__